import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const env = window._env_ || {};
const OIDC_AUTHORITY = env.REACT_APP_OIDC_ISSUER || process.env.REACT_APP_OIDC_ISSUER || '';
const CLIENT_ID = env.REACT_APP_OIDC_CLIENT_ID || process.env.REACT_APP_OIDC_CLIENT_ID || 'image-factory';
const REDIRECT_URI = window.location.origin + '/callback';
const POST_LOGOUT_REDIRECT_URI = window.location.origin + '/';

// OIDC PKCE configuration
// Provide metadata directly and proxy token/userinfo/keys through nginx
// to avoid CORS issues with Dex (which does not set CORS headers)
const OIDC_PROXY = window.location.origin + '/oidc-proxy';

export const oidcConfig = {
  authority: OIDC_AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: REDIRECT_URI,
  post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid email profile groups offline_access',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: sessionStorage }),
  metadata: {
    issuer: OIDC_AUTHORITY,
    // Full-page redirect - no CORS issue
    authorization_endpoint: `${OIDC_AUTHORITY}/auth`,
    // Fetch requests - proxy through nginx to avoid CORS
    token_endpoint: `${OIDC_PROXY}/token`,
    userinfo_endpoint: `${OIDC_PROXY}/userinfo`,
    jwks_uri: `${OIDC_PROXY}/keys`,
  },
};

let userManager = null;

export function getUserManager() {
  if (!userManager && OIDC_AUTHORITY) {
    userManager = new UserManager(oidcConfig);
  }
  return userManager;
}

// In-memory token reference (populated by AuthProvider via onSigninCallback)
let currentToken = null;

export function setCurrentToken(token) {
  currentToken = token;
}

export function getToken() {
  return currentToken;
}

export function clearToken() {
  currentToken = null;
}
